<!-- src/components/HorizontalItem.vue -->
<template>
    <q-card v-ripple @click="fun(item)" class="q-ma-sm" style="max-width: 200px; min-width: 180px; max-height: 180px;">
      <q-img :src="baseURL +`/image` + item.image" alt="Item Image" fit="cover" style="max-width: 150px; height: 80px;" />
      <q-card-section class="q-mb-md">
        <div class="text" style="word-wrap: break-word; text-align: center;">{{ item.title }}</div>
      </q-card-section>
    </q-card>
    
  </template>
  
  <script>
  import { baseURL } from "@/service/client";
  export default {
    data() {
      return {
        baseURL,
      };
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
      fun: {
        type: Function,
        required: true,
      }
    },
  };
  </script>
  